import AddCustomer from 'AppointmentBox/CustomerTab/AddCustomer';
import { addCustomerRef } from 'AppointmentBox/signal';
import Box from 'components/Box';
import styled from 'styled-components';
import { ICustomerUI } from 'types/customer';
import { formatNumber } from 'utils/formatCurrency';
import { formatPhone } from 'utils/formatPhone';
import ButtonEditCustomer from '../AppointmentBox/CustomerTab/ButtonEditCustomer';
import CustomerSection, { customerSectionRef } from './Customer';
import qbSignal from './signal';


const CustomerQuickBookingSection = () => {
  const handleChooseCustomer = (o: ICustomerUI) => {
    qbSignal.customer.value = o;
  };

  return (
    <div className="section-wrapper" style={{ flex: 1 }}>
      <div className='customer-staff-item' style={{ flex: 1 }}>
        <Box gap='2' display='flex' alignItems='end' justifyContent='center' style={{ flex: 1 }}>
          <CustomerSectionStyled v2 ref={customerSectionRef} key={qbSignal.uuidKey.value} />
          <AddCustomerStyled v2 ref={addCustomerRef} onSelect={handleChooseCustomer} />
        </Box>
      </div>
      <CustomerInfoSectionBox display={'flex'} alignItems='center' className='customer-staff-item' style={{ flex: 1 }}>
        <Box flex={1} gap='4' display='flex' alignItems='end' justifyContent='start'>
          <p className='customer-name'>{qbSignal.customer.value?.name || 'Walk-In - (000) 000-0000'} {qbSignal.customer.value?.phone ? ' - ' + formatPhone(qbSignal.customer.value?.phone || '') : ''}</p>
          {!!qbSignal.customer.value && <>
            <span className='customer-name'>-</span>
            <p className='customer-points'>{formatNumber(qbSignal.customer.value?.point || 0)} points</p>
          </>}
        </Box>
        <ButtonEditCustomer onSelect={handleChooseCustomer} visible={!!qbSignal.customer.value?.id} customerId={Number(qbSignal.customer.value?.id)} />
      </CustomerInfoSectionBox>
    </div>
  );
};

export default CustomerQuickBookingSection;


const CustomerInfoSectionBox = styled(Box)`
  .customer-name {
    color: #1D2129;
    font-family: Poppins;
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
    text-transform: capitalize;
  }
  .customer-points {
    color: #F05326;
    font-family: Poppins;
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
    text-transform: capitalize;
  }
`;

const CustomerSectionStyled = styled(CustomerSection)`
  flex: 1;
  .wrapper-input .customer-selected {
    right: 4px;
  }
`;

const AddCustomerStyled = styled(AddCustomer)`
  .icon-add {
    width: 50px;
    height: 50px;
  }
`;
